import { useState } from "react";

const ConciliacionPagos = () => {
  const [transferencias, setTransferencias] = useState([
    { id: 1, paciente: "Juan Pérez", monto: 50000, estado: "Pendiente" },
    { id: 2, paciente: "María González", monto: 60000, estado: "Pendiente" },
  ]);
  const [modalVisible, setModalVisible] = useState(false);
  const [nuevoPaciente, setNuevoPaciente] = useState("");
  const [nuevoMonto, setNuevoMonto] = useState("");

  const agregarTransferencia = () => {
    setTransferencias([
      ...transferencias,
      { id: transferencias.length + 1, paciente: nuevoPaciente, monto: parseFloat(nuevoMonto), estado: "Pendiente" },
    ]);
    setModalVisible(false);
    setNuevoPaciente("");
    setNuevoMonto("");
  };

  const actualizarEstado = (id, estado) => {
    setTransferencias(
      transferencias.map((t) => (t.id === id ? { ...t, estado } : t))
    );
  };

  return (
    <div className="container mt-4">
      <div className="card p-3">
        <h4>Conciliación de Pagos</h4>
        <button className="btn btn-primary mb-3" onClick={() => setModalVisible(true)}>
          Agregar Transferencia
        </button>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Paciente</th>
              <th>Monto</th>
              <th>Estado</th>
              <th>Acción</th>
            </tr>
          </thead>
          <tbody>
            {transferencias.map((t) => (
              <tr key={t.id}>
                <td>{t.paciente}</td>
                <td>${t.monto}</td>
                <td>{t.estado}</td>
                <td>
                  {t.estado === "Pendiente" && (
                    <>
                      <button className="btn btn-success me-2" onClick={() => actualizarEstado(t.id, "Aceptado")}>
                        Aceptar
                      </button>
                      <button className="btn btn-danger" onClick={() => actualizarEstado(t.id, "Rechazado")}>
                        Rechazar
                      </button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modalVisible && (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Agregar Transferencia</h5>
                <button type="button" className="close" onClick={() => setModalVisible(false)}>
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">Paciente:</label>
                  <input
                    type="text"
                    className="form-control"
                    value={nuevoPaciente}
                    onChange={(e) => setNuevoPaciente(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Monto:</label>
                  <input
                    type="number"
                    className="form-control"
                    value={nuevoMonto}
                    onChange={(e) => setNuevoMonto(e.target.value)}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setModalVisible(false)}>Cerrar</button>
                <button className="btn btn-primary" onClick={agregarTransferencia}>Guardar</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConciliacionPagos;
